import {store} from  '../store'

export default(to, from,next) =>{
  if(store.getters.user){
      next();
  }else{
    next('/');
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js